import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiClientService } from '../../../shared/api-client.service';
import { NewWidgetModalComponent } from '../../shared/modals/new-widget-modal/new-widget-modal.component';
import { ModalService } from '../../shared/modals/shared/modal/modal.service';
import { MunicipalityCodeSelectionService } from '../../shared/municipality-code-selection.service';
import { FeatureFlipperService } from './../../../shared/feature-flipper.service';
import { DashboardGridItemConfig } from './models/dashboard-grid-item-config.model';
import { Dashboard } from './models/dashboard.model';

@Injectable()
export class DashboardService {
  public userDashboards = new BehaviorSubject<Array<any>>([]);

  constructor(
    private apiClientService: ApiClientService,
    protected municipalityCodeSelectionService: MunicipalityCodeSelectionService,
    protected modalService: ModalService,
    protected featureFlipper: FeatureFlipperService
  ) {
    if (this.featureFlipper.enabled('dashboard_builder'))
      this.fetchUserDashboards().subscribe();
  }

  loadGridOptions(url: string): Observable<any> {
    return this.apiClientService.get(url);
  }

  uploadDashboardConfig(dashboard: Dashboard): Observable<any> {
    if (!dashboard.id)
      return this.apiClientService.post('/dashboard_config', {
        dashboardConfig: JSON.stringify(dashboard.config)
      });
    else
      return this.apiClientService.patch('/dashboard_config', {
        id: dashboard.id,
        title: dashboard.title,
        icon: dashboard.icon,
        config: JSON.stringify(dashboard.config)
      });
  }

  cleanUpDashboardConfigurations(): Observable<Response> {
    return this.apiClientService.get('/dashboard_config/clean_up');
  }

  fetchUserDashboards() {
    return this.apiClientService.get('/dashboard_config/routes').map(data => {
      this.userDashboards.next(data.dashboardRoutes);
    });
  }

  removeDashboard(dashboard: Dashboard) {
    return this.apiClientService.delete('/dashboard_config?id=' + dashboard.id);
  }

  addNewWidgetClicked(
    widgetConfiguration: DashboardGridItemConfig = null
  ): Observable<DashboardGridItemConfig> {
    return new Observable(observer => {
      this.modalService.createNewModal({
        component: NewWidgetModalComponent,
        inputs: {
          widgetConfiguration: widgetConfiguration,
          handleSave: (newWidgetConfiguration: DashboardGridItemConfig) => {
            this.modalService.setModalActive(false);
            observer.next(newWidgetConfiguration);
            observer.complete();
          }
        }
      });
      this.modalService.setModalActive(true);
    });
  }
}
